var map = {
	"./rule-content-ar.png": "dcc7",
	"./rule-content-en.png": "a598",
	"./rule-content-in.png": "a26f",
	"./rule-content-ms.png": "a7aa",
	"./rule-content-zh.png": "e403"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "374b";